import { Box, Divider, Typography } from "@mui/material";
import { ICreateMarathon } from "features/createEditMarathon/model/types";
import {
  Control,
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFormRegister,
} from "react-hook-form";
import { Partner } from "./Partner";
import style from "../loadFile/loadFile.module.scss";
import { useTranslation } from "react-i18next";

interface ILoadDocumentProps {
  data: ICreateMarathon;
  remove: (index: number) => void;
  append: UseFieldArrayAppend<ICreateMarathon, "partners">;
  register: UseFormRegister<ICreateMarathon>;
  fields: FieldArrayWithId<ICreateMarathon, "partners", "id">[];
  indexLanguage: number;
  control: Control<ICreateMarathon, any>;
}

export const Partners: React.FC<ILoadDocumentProps> = ({
  data,
  remove,
  append,
  fields,
  control,
  register,
  indexLanguage,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          gap: "16px",
          pb: "16px",
        }}
      >
        <Typography
          sx={{ fontSize: "16px", lineHeight: "24px", fontFamily: "Raleway" }}
        >
          {t("createMarathon.partners")}
        </Typography>
        <Divider sx={{ flex: "1", background: "#ECF2F7" }} />
      </Box>
      {fields.map((partner, index) => {
        return (
          <Partner
            key={partner.id}
            {...{
              data,
              control,
              remove,
              append,
              fields,
              register,
              indexLanguage,
              index,
              partner,
            }}
          />
        );
      })}
      <label
        className={style.text_add}
        onClick={() => {
          const maxSerialNumber = Math.max(...fields.map(partner => partner.serialNumber || 0), 0);
          const nextSerialNumber = maxSerialNumber + 1;

          append({
            id: "random",
            partnerCompanies: [],
            serialNumber: nextSerialNumber,
            translations: [
              {
                name: "",
                languageId: 1,
              },
              {
                name: "",
                languageId: 2,
              },
              {
                name: "",
                languageId: 3,
              },
            ],
          },
            { shouldFocus: false }
          );
        }}
      >
        {t("createMarathon.addPartner")}
      </label>
    </Box>
  );
};
